import axios from "../../axiosDod.js";
const getDodCustomers = async ({ commit }, data) => {
  const params = { limit: Number.MAX_SAFE_INTEGER };
  if (data.limit) {
    params.limit = data.limit;
  }
  if (data.page) {
    params.page = data.page;
  }
  if (data) {
    const { statusId, search, notScheduled, filters } = data;
    if (statusId) {
      params.customersStatusesIds = statusId;
    }
    if (search) {
      params.search = search;
    }
    if (notScheduled && Number(notScheduled) !== 0) {
      params.notScheduledAllHours = notScheduled;
    }
    if (filters) {
      for (const [key, value] of Object.entries(filters)) {
        params[key] = value;
      }
    }
  }

  const customers = await axios.get(`customers`, { params });
  commit("SET_DOD_CUSTOMERS", customers.data);
};

const getDodCustomersInMonth = async ({ commit }, data) => {
  const { month, year, filters, search, limit, page } = data;
  const params = { limit: Number.MAX_SAFE_INTEGER, month, year };
  if (search) {
    params.search = search;
  }
  if (filters) {
    for (const [key, value] of Object.entries(filters)) {
      params[key] = value;
    }
  }
  if (limit) {
    params.limit = limit;
  }
  if (page) {
    params.page = page;
  }

  const response = await axios.get(`customers/byMonth`, { params });
  commit("SET_DOD_CUSTOMERS_IN_MONTH", response.data);
};

const addCustomer = async ({ dispatch }, data) => {
  try {
    const response = await axios.post(`customers`, data);
    dispatch("fetchStatusesCounters");
    return response.data;
  } catch {
    return false;
  }
};

// Sprawdzenie przed dodaniem: czy podopieczny o tym imieniu, nazwisku i telefonie już jest.
// Zwraca znaleziony rekord albo null. Błąd samego sprawdzenia nie może blokować dodawania,
// dlatego lecimy wtedy dalej - po stronie backendu i tak stoi blokada na zapisie.
const checkCustomerDuplicate = async (_, data) => {
  try {
    const response = await axios.post(`customers/checkDuplicate`, data);
    return response?.data?.duplicate || null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const removeCustomer = async (_, customerId) => {
  try {
    const response = await axios.delete(`customers/${customerId}`);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

const setCustomerFetchParams = async ({ commit }, data) => {
  commit("SET_CUSTOMER_FETCH_PARAMS", data);
};

const getCustomerDetails = async ({ commit, getters, dispatch }, payload) => {
  const { customerId, ordersMonth, ordersYear } = payload;
  let params = { search: customerId, withDetails: true };
  const customerFetchParams = getters.getDodCustomerFetchParams;
  if (ordersMonth) {
    params.ordersMonth = ordersMonth;
  } else if (customerFetchParams.ordersMonth) {
    params.ordersMonth = customerFetchParams.ordersMonth;
  }
  if (ordersYear) {
    params.ordersYear = ordersYear;
  } else if (customerFetchParams.ordersYear) {
    params.ordersYear = customerFetchParams.ordersYear;
  }

  const response = await axios.get(`customers/${customerId}`);
  if (response && response.data) {
    commit("SET_DOD_SELECTED_CUSTOMER", response.data);

    await dispatch("getCustomerPaymentForMonth", {
      customerId,
      year: params.ordersYear || null,
      month: params.ordersMonth || null,
    });
  }
};

const getCustomerMessages = async ({ commit }, payload) => {
  const { customerId, selectedTab } = payload;
  let params = { customerId, limit: Number.MAX_SAFE_INTEGER };
  if (selectedTab && selectedTab !== "ALL") {
    if (selectedTab === "Komentarze") {
      params.isAction = false;
    }
    if (selectedTab === "Aktywność") {
      params.isAction = true;
    }
  }
  const response = await axios.get(`messages`, {
    params,
  });
  commit("SET_DOD_SELECTED_CUSTOMER_MESSAGES", response.data);
};

const getCustomerOrders = async ({ commit, getters }, payload) => {
  const { customerId, ordersMonth, ordersYear } = payload;
  const customerFetchParams = getters.getDodCustomerFetchParams;
  const response = await axios.get(`orders`, {
    params: {
      withDetails: true,
      ordersMonth: ordersMonth || customerFetchParams.ordersMonth,
      ordersYear: ordersYear || customerFetchParams.ordersYear,
      customerId,
      limit: Number.MAX_SAFE_INTEGER,
    },
  });
  commit("SET_DOD_SELECTED_CUSTOMER_ORDERS", response.data);
  return response.data;
};

const getCustomerSchedule = async ({ commit, getters }, payload) => {
  const { customerId, ordersMonth, ordersYear } = payload;
  const customerFetchParams = getters.getDodCustomerFetchParams;

  const response = await axios.get(`customerSchedules`, {
    params: {
      ordersMonth: ordersMonth || customerFetchParams.ordersMonth,
      ordersYear: ordersYear || customerFetchParams.ordersYear,
      customerId,
      limit: Number.MAX_SAFE_INTEGER,
    },
  });
  commit("SET_DOD_SELECTED_CUSTOMER_SCHEDULE", response.data);
};

const getCustomerSchedulesByMonthAndYear = async ({ commit }, payload) => {
  const { customerId, dates } = payload;

  const schedulesByMonthAndYear = [];
  for await (let date of dates) {
    const response = await axios.get(`customerSchedules`, {
      params: {
        ordersMonth: date.month,
        ordersYear: date.year,
        customerId,
        limit: Number.MAX_SAFE_INTEGER,
      },
    });
    schedulesByMonthAndYear.push({
      month: date.month,
      year: date.year,
      schedule: response.data?.data,
    });
  }
  commit(
    "SET_DOD_CUSTOMER_SCHEDULES_BY_MONTH_AND_YEAR",
    schedulesByMonthAndYear
  );
};

const getCustomerScheduleDaysBetweenDates = async (_, payload) => {
  const { customerId, dateFrom, dateTo } = payload;
  const response = await axios.get(`customerScheduleDays/dates`, {
    params: { customerId, dateFrom, dateTo },
  });
  return response.data;
};

const getCustomerPayments = async ({ commit }, payload) => {
  const { customerId } = payload;
  const response = await axios.get(`payments`, {
    params: { customerId, limit: Number.MAX_SAFE_INTEGER },
  });
  commit("SET_DOD_SELECTED_CUSTOMER_PAYMENTS", response.data);
};

const getCustomerAttachments = async ({ commit }, payload) => {
  const { customerId } = payload;
  const response = await axios.get(`customers/${customerId}/files`);
  commit("SET_DOD_SELECTED_CUSTOMER_ATTACHMENTS", response.data);
};

const resetCustomerDetails = async ({ commit }) => {
  commit("SET_DOD_SELECTED_CUSTOMER", null);
};

const addCustomerSchedule = async ({ dispatch }, data) => {
  try {
    const response = await axios.post(`customerSchedules`, data);
    dispatch("fetchStatusesCounters");
    if (response && response.data) {
      return true;
    }
  } catch (error) {
    console.log(error);
    return false;
  }
};

const editDodCustomer = async ({ dispatch }, payload) => {
  try {
    const { data, customerId } = payload;
    await axios.put(`customers/${customerId}`, data);
    dispatch("fetchStatusesCounters");
    return true;
  } catch (error) {
    return false;
  }
};

const addCustomerPayment = async (_, data) => {
  try {
    await axios.post(`payments`, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const getCustomerPaymentForMonth = async ({ commit, getters }, data) => {
  try {
    const customerFetchParams = getters.getDodCustomerFetchParams;
    const { customerId, year, month } = data;
    const params = {
      customerId,
      year: year || customerFetchParams.ordersYear,
      month: month || customerFetchParams.ordersMonth,
    };
    const response = await axios.get(`customers/paymentForMonth`, { params });
    if (response?.data) {
      commit("SET_DOD_SELECTED_CUSTOMER_PAYMENT", response.data.sumOfPayments);
    }
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default {
  getDodCustomers,
  addCustomer,
  getCustomerDetails,
  resetCustomerDetails,
  addCustomerSchedule,
  editDodCustomer,
  addCustomerPayment,
  getCustomerPaymentForMonth,
  getCustomerMessages,
  getCustomerOrders,
  getCustomerSchedule,
  getCustomerPayments,
  getDodCustomersInMonth,
  getCustomerAttachments,
  setCustomerFetchParams,
  removeCustomer,
  getCustomerScheduleDaysBetweenDates,
  getCustomerSchedulesByMonthAndYear,
  checkCustomerDuplicate,
};
